import React from 'react';

export default function SimplePieChart({ data, size = 200 }) {
    const total = data.reduce((sum, d) => sum + d.value, 0);
    if (total === 0) {
        return <div style={{ width: size, height: size, borderRadius: '50%', background: '#eee' }} />;
    }
    let current = 0;
    const segments = data.map(d => {
        const start = (current / total) * 100;
        current += d.value;
        const end = (current / total) * 100;
        return `${d.color} ${start}% ${end}%`;
    });
    const background = `conic-gradient(${segments.join(',')})`;
    return (
        <div style={{ width: size, height: size, borderRadius: '50%', background }} />
    );
}

